import React from "react";
import { connect } from "react-redux";
import { getShortenName } from "../../../../utils/functions/javaScriptHelper";
import { getCompanyAccountType } from "../../../../reducers/companySelector";
import {
	CompanyAccountType,
	RestrictedCompanyAccountType,
} from "../../../../utils/constants";
import { useTranslation } from "react-i18next";
import { Tooltip } from "antd";
import {
	BranchNameIcon,
	CertificateIcon,
	CollegeIcon,
	ProjectIcon,
} from "../../../common/icons";
import "./studentCardv2.css";

const getChildren = (index, children) => {
	if (!children) return null;
	if (!children.props) return null;
	if (children.props.children) {
		return children.props.children[index];
	} else {
		if (index === 0) return children;
		return null;
	}
};

const StudentCard = ({
	student,
	children,
	onClick,
	isActionInProgress,
	accountType,
	acceptedInterviewSlot,
}) => {
	const { t } = useTranslation();
	const showStudentDetails = () => {
		onClick(student.id);
	};

	const isRestrictedAccountType =
		RestrictedCompanyAccountType.includes(accountType);

	return (
		<div
			className="studentCardv2_container"
			onClick={!isActionInProgress && showStudentDetails}
			id={student.id}
		>
			{acceptedInterviewSlot && (
				<div className="bookedInterviewSlot">{acceptedInterviewSlot}</div>
			)}
			<div className="studentCardv2_row1">
				<div
					className="studentCardv2_row1_children_container"
					onClick={(e) => e.stopPropagation()}
				>
					{getChildren(0, children)}
				</div>
				<div className="studentCardv2_row1_profilePicture_container">
					<img
						src={student.img}
						className="studentCardv2_row1_profilePicture"
						alt="candidateAvatar"
					/>
				</div>
				<div className="studentCardv2_row1_banner_container">
					<div className="studentCardv2_row1_banner_row1">
						<div style={{ display: "flex", gap: 8 }}>
							<div className="b1">
								<span>
									{`Good for ${t("project")} #${
										student.goodForProjectNumber || "~"
									}`}
								</span>
							</div>
							{getChildren(1, children)}
						</div>
						<div>{getChildren(2, children)}</div>
					</div>
					<div className="studentCardv2_row1_banner_row2">
						<div className="b1">
							<span>
								{t(
									"studentDetailsDialogue_body_tabProfile_banner_cumulativeScore"
								)}
								: {student.galkRecruitCumulativeScore || "~"}
							</span>
						</div>
						<div className="b2">
							<span>
								{t(
									"studentDetailsDialogue_body_tabProfile_banner_interviewPoints"
								)}
								: {student.interviewPoints || "~"}
							</span>
						</div>
					</div>
					<div className="studentCardv2_row1_studentName">
						{isRestrictedAccountType
							? "Student Name"
							: getShortenName({
									name: student.name,
									collegeName: student.collegeName,
							  })}
					</div>
					<div className="studentCardv2_row1_collegeName">
						<CollegeIcon width={16} height={16} />
						<span style={{ marginLeft: 6 }}>{student.collegeName}</span>
					</div>
					<div className="studentCardv2_row1_branchName">
						<BranchNameIcon width={16} height={16} />
						<span style={{ marginLeft: 6 }}>{student.branchName}</span>
					</div>
				</div>
				{/* <div
					className="studentCardv2_row1_children_container"
					onClick={(e) => e.stopPropagation()}
				>
					{children}
				</div> */}
			</div>
			<div className="studentCardv2_row2">
				<div key="headerUl1">
					<CertificateIcon width={16} height={16} />
					<span>{student.certificates ? student.certificates.length : 0}</span>
					<span>
						{t("studentDetailsDialogue_body_tabProfile_certificateTag")}
					</span>
				</div>
				<div key="headerUl2">
					<ProjectIcon width={16} height={16} />
					<span> {student.projects ? student.projects.length : 0}</span>
					<span>{t("studentDetailsDialogue_body_tabProfile_projectTag")}</span>
				</div>
			</div>
			<div className="studentCardv2_row3">
				{[...student.skills].splice(0, 3).map((skill, i) => (
					<React.Fragment key={i}>
						{typeof skill === "string" && (
							<div key={`${skill}-string-${i}`}>{skill}</div>
						)}
						{typeof skill === "object" && (
							<div key={`${skill}-object-${i}`}>{skill.label}</div>
						)}
					</React.Fragment>
				))}
				{student.skills.length > 3 && (
					<div key="skills-more">{`+ ${student.skills.length - 3}`}</div>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	accountType: getCompanyAccountType(state),
});

export default connect(mapStateToProps, {})(StudentCard);
